import { render, staticRenderFns } from "./ReactionTestsNewTest.vue?vue&type=template&id=45f8d968&"
import script from "./ReactionTestsNewTest.vue?vue&type=script&lang=js&"
export * from "./ReactionTestsNewTest.vue?vue&type=script&lang=js&"
import style0 from "./ReactionTestsNewTest.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "ReactionTestsNewTest.vue"
export default component.exports